export default "__VITE_ASSET__3RATbpfx__"